<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #ac8400">Total Registration</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #f2f2f2">
      <router-link to="/dashboard"> Dashboard </router-link> /

      <b>Marketing</b> /

      <b>Total Registration</b>
    </div>
    <!-- End of breadcrumbs -->

    <p></p>

    <div class="separator-breadcrumb border-top"></div>

    <div class="row">
      <div class="col-12">
        <button
          class="btn btn-primary mr-2"
          @click="loadDailyChart"
          v-show="showChart"
        >
          Daily Verified Registration
        </button>
        <button
          class="btn btn-primary"
          @click="loadAccumulativeChart"
          v-show="showChart"
        >
          Verified Accumulative
        </button>
        <div class="float-right">
          <button class="btn btn-primary mr-2" @click="toggleShowChart">
            Switch to {{ showChart ? "table" : "chart" }}
          </button>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div id="chart" style="height: 700px" v-show="showChart"></div>
            <div id="table-wrapper" style="height: 700px" v-show="!showChart">
              <table
                id="total_registration_table"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Daily Verified Registrations</th>
                    <th>Total Verified Registrations</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(report, index) in reports" v-bind:key="index">
                    <td>{{ report.registration_date }}</td>
                    <td>{{ report.daily }}</td>
                    <td>{{ report.accumulative }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "total-registration",
  components: {},

  data() {
    return {
      showChart: true,
      echart: null,
      reports: [],
      dates: [],
      daily_data: [],
      accumulative_data: [],
      data_zoom: []
    };
  },
  methods: {
    async loadReport() {
      let token = localStorage.getItem("token");

      if (token === null) {
        return false;
      }

      token = JSON.parse(token);
      token = token.access_token;

      const { data } = await axios.get("/reports/total_registrations", {
        headers: {
          Authorization: "Bearer " + token
        }
      });

      this.reports = data.report;
      const dates = this.getDates(data.report);
      const daily_counts = this.getDailyCounts(data.report);
      const accumulative_counts = this.getAccumulativeCounts(data.report);

      this.dates = dates;

      this.daily_data = daily_counts;
      this.accumulative_data = accumulative_counts;

      this.data_zoom = [
        {
          type: "slider",
          show: true,
          startValue: dates.length - 60,
          endValue: dates.length
        }
      ];

      this.loadDailyChart();
    },

    loadDailyChart() {
      this.echart.setOption({
        xAxis: {
          type: "category",
          data: this.dates
        },
        yAxis: {
          type: "value"
        },
        dataZoom: this.data_zoom,
        series: [
          {
            label: {
              show: true,
              position: "top",
              formatter: "{c}"
            },
            data: this.daily_data,
            type: "bar",
            itemStyle: {
              color: "#AC8400"
            },
            showBackground: true,
            backgroundStyle: {
              color: "rgba(220, 220, 220, 0.8)"
            }
          }
        ]
      });
    },

    loadAccumulativeChart() {
      this.echart.setOption({
        xAxis: {
          type: "category",
          data: this.dates
        },
        yAxis: {
          type: "value"
        },
        dataZoom: this.data_zoom,
        series: [
          {
            label: {
              show: true,
              position: "top",
              formatter: "{c}"
            },
            data: this.accumulative_data,
            type: "bar",
            itemStyle: {
              color: "#AC8400"
            },
            showBackground: true,
            backgroundStyle: {
              color: "rgba(220, 220, 220, 0.8)"
            }
          }
        ]
      });
    },

    getDates(report) {
      return report.map(r => r.registration_date);
    },

    getDailyCounts(report) {
      return report.map(r => r.daily);
    },

    getAccumulativeCounts(report) {
      return report.map(r => r.accumulative);
    },

    toggleShowChart() {
      this.showChart = !this.showChart;

      if (this.showChart) {
        this.loadReport();
      }

      if (
        !this.showChart &&
        !$.fn.DataTable.isDataTable("#total_registration_table")
      ) {
        $("#total_registration_table")
          .DataTable()
          .destroy();

        $("#total_registration_table").DataTable({
          dom: "Bfrtip",
          buttons: ["excel", "pdf"]
        });
      }
    }
  },

  mounted() {
    this.echart = echarts.init(document.getElementById("chart"));
    this.loadReport();
  }
};
</script>
